export default function (state, item) {
    state.list.push(item);
}